import { HistoryPanelContactLeaversDocument } from 'generated/resources/graphql'

import { useLazyQuery } from 'modules/core/hooks/useQuery'

type FetchLeaversParams = {
  employeeIds: number[]
  startDate: string
  endDate: string
  itemsPerPage: number
  lastCursor?: string
}

export const useLeavers = () => {
  const [fetchLeavers, { data, loading, error }] = useLazyQuery(HistoryPanelContactLeaversDocument)

  const fetch = ({
    employeeIds,
    startDate,
    endDate,
    itemsPerPage,
    lastCursor,
  }: FetchLeaversParams) => {
    fetchLeavers({
      variables: {
        employeeIds,
        startDate,
        endDate,
        itemsPerPage,
        after: lastCursor,
      },
    })
  }

  return {
    fetch,
    data,
    loading,
    error,
  }
}
